import { Organization } from './Organization';
import OrganizationRepository from './OrganizationRepository';

export default class OrganizationService {
  private readonly organizationRepository: OrganizationRepository =
    new OrganizationRepository();

  async getOrganizations({
    name = null,
  }: {
    name?: null | string;
  }): Promise<Organization> {
    return this.organizationRepository.getOrganizations({ name });
  }

  async getOrganizationsSettings(id: number | string) {
    return this.organizationRepository.getOrganizationsSettings(id);
  }

  async postOrganization(data: any) {
    return this.organizationRepository.postOrganization(data);
  }

  async putOrganization(organizationId: string, data: any) {
    return this.organizationRepository.putOrganization(organizationId, data);
  }

  async deleteOrganization(organizationId: string) {
    return this.organizationRepository.deleteOrganization(organizationId);
  }
}
